export default __webpack_public_path__ + "static/media/blockchain.d06b5762.jpg";